import { useFormContext } from 'react-hook-form'

import { TransactionMemoInput } from '~/components/inputs/custom/TransactionMemoInput'
import { type MemoFormValues } from '~/components/smart-accounts/schemas'

export const TransactionMemoSection = ({
  autoFocus,
}: {
  autoFocus?: boolean
}) => {
  const { control } = useFormContext<MemoFormValues>()

  return (
    <TransactionMemoInput
      control={control}
      inputName="memo"
      autoFocus={autoFocus}
    />
  )
}
